import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {ChartImageUrls} from './helpers/chart-image-urls';

/** The addresses of the images of the charts, see [ChartImageUrls]. */
@Injectable({providedIn: 'root'})
export class ChartImageUrlsService extends ChartImageUrls {
  constructor() {
    super(environment.s3bucket);
  }
}
